/*
 *
 * File: bookings_reducer.js
 *
 * Purpose: Booking data reducer.
 *
 * Author:  Thomas Burgard (Software development)
 * Created: 03.04.2023
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import { GET_BOOKINGDATA, GET_PASSENGER_BOOKINGS } from "../types";

/**
 * Booking data reducer function.
 *
 * @param {*} state Redux state as app wide store (initial state is empty)
 * @param {*} action which action is then processing
 * @returns state
 */
export default function bookingReducer(
  state = {
    bookingData: { 
      Success: false, 
      BookingData: "Wrong" 
    },
  },
  action
) {
  switch (action.type) {
    // Get booking data from Server
    case GET_BOOKINGDATA:
      return { ...state, ...action.payload };
    case GET_PASSENGER_BOOKINGS:
      state.bookingData.BookingData = "Data received";
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
